/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import { DataConnectionItemFragmentDoc } from "../data-connection-item/DataConnectionItem.generated";
import {
  CategoryFragmentDoc,
  StatusFragmentDoc,
} from "../../app/ProjectLabels.generated";
import { TableListFragmentDoc } from "../../sidebar/data-browser/DataBrowserTableList.generated";
import {
  PinnedSemanticDatasetFragmentDoc,
  PinnedSchemaFragmentDoc,
} from "../../sidebar/data-browser/FavoritesView.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type RefreshSchemaMutationVariables = Types.Exact<{
  dataConnectionId: Types.Scalars["DataConnectionId"]["input"];
  appSessionId?: Types.InputMaybe<Types.Scalars["AppSessionId"]["input"]>;
}>;

export type RefreshSchemaMutation = {
  readonly __typename: "Mutation";
  readonly refreshDataConnectionSchema: {
    readonly __typename: "DataConnection";
    readonly id: c.DataConnectionId;
    readonly connectionName: string;
    readonly connectionType: c.DataConnectionType;
    readonly connectionDescription: string | null;
    readonly enableChdb: boolean | null;
    readonly allowWriteback: boolean;
    readonly lastRefreshed: c.DateTimeString | null;
    readonly hasDetails: boolean;
    readonly hasDbtMetadata: boolean;
    readonly dbtErrorMessages: ReadonlyArray<string> | null;
    readonly dbtMetadataError: boolean;
    readonly dbtMetadataErrorMessages: ReadonlyArray<string> | null;
    readonly hasDbtMetrics: boolean;
    readonly dbtMetricsError: boolean;
    readonly dbtMetricsErrorMessages: ReadonlyArray<string> | null;
    readonly schemaRefreshErrorMessages: ReadonlyArray<string> | null;
    readonly isDemoConnection: boolean;
    readonly demoDataConnectionId: c.DemoDataConnectionId | null;
    readonly isMultiDatabase: boolean;
    readonly status: string | null;
    readonly hexId: c.HexId | null;
    readonly enableSnowpark: boolean;
    readonly authenticationType: string | null;
    readonly canRefreshSchema: boolean;
    readonly isDefault: boolean;
    readonly statusDetails: {
      readonly __typename: "DataConnectionStatusDetails";
      readonly refreshEnqueuedDetails: {
        readonly __typename: "EnqueuedStatusDetails";
        readonly pendingDataConnectionCount: number;
      } | null;
    };
    readonly oauthSettings: {
      readonly __typename: "DataConnectionOAuthSettings";
      readonly id: c.DataConnectionOAuthSettingsId;
      readonly logicViewSetting: Types.OAuthLogicViewSetting;
      readonly publishedAppSetting: Types.OAuthPublishedAppSetting;
      readonly userScopedResultsSetting: Types.OAuthUserScopedResultsSetting;
    } | null;
    readonly passthroughOAuthInfo: {
      readonly __typename: "PassthroughOAuthInfo";
      readonly dataConnectionId: c.DataConnectionId;
      readonly dataConnectionName: string;
      readonly dataConnectionType: c.OAuthConnectionType;
      readonly oAuthConnectionId: string;
      readonly hasValidToken: boolean;
      readonly currentRole: string | null;
      readonly requiredRole: string | null;
      readonly authWithSso: boolean;
    } | null;
    readonly grants: ReadonlyArray<{
      readonly __typename: "SharedAssetGrant";
      readonly id: c.SharedAssetGrantId;
      readonly role: Types.SharedAssetRole;
      readonly holder:
        | { readonly __typename: "Group"; readonly groupId: c.GroupId }
        | {
            readonly __typename: "IntrinsicGroup";
            readonly name: string;
            readonly intrinsicGroupId: Types.IntrinsicGroupId;
          };
    }>;
  };
};

export type DataConnectionRefreshProgressSubscriptionVariables = Types.Exact<{
  dataConnectionId: Types.Scalars["DataConnectionId"]["input"];
}>;

export type DataConnectionRefreshProgressSubscription = {
  readonly __typename: "Subscription";
  readonly dataConnectionRefreshProgress: {
    readonly __typename: "DataConnectionRefreshProgressPayload";
    readonly dataConnectionId: c.DataConnectionId;
    readonly currentProgress: number;
    readonly finishedProgress: number;
    readonly section: Types.DataConnectionRefreshSection;
  };
};

export type DataConnectionRefreshSubscriptionVariables = Types.Exact<{
  dataConnectionId: Types.Scalars["DataConnectionId"]["input"];
}>;

export type DataConnectionRefreshSubscription = {
  readonly __typename: "Subscription";
  readonly dataConnectionRefresh: {
    readonly __typename: "DataConnection";
    readonly id: c.DataConnectionId;
    readonly status: string | null;
    readonly lastRefreshed: c.DateTimeString | null;
    readonly dbtErrorMessages: ReadonlyArray<string> | null;
    readonly dbtMetadataError: boolean;
    readonly dbtMetadataErrorMessages: ReadonlyArray<string> | null;
    readonly hasDbtMetadata: boolean;
    readonly dbtMetricsError: boolean;
    readonly dbtMetricsErrorMessages: ReadonlyArray<string> | null;
    readonly hasDbtMetrics: boolean;
    readonly databases: ReadonlyArray<{
      readonly __typename: "DataSourceDatabase";
      readonly id: c.DataSourceDatabaseId;
      readonly name: string | null;
    }>;
  };
};

export type DataConnectionOAuthMigrationProgressSubscriptionVariables =
  Types.Exact<{
    dataConnectionId: Types.Scalars["DataConnectionId"]["input"];
  }>;

export type DataConnectionOAuthMigrationProgressSubscription = {
  readonly __typename: "Subscription";
  readonly dataConnectionOAuthMigrationProgress: {
    readonly __typename: "DataConnectionOAuthMigrationProgressPayload";
    readonly dataConnectionId: c.DataConnectionId;
    readonly currentProgress: number;
    readonly totalProgress: number;
    readonly status: Types.OAuthMigrationStatus;
  };
};

export type GetDataConnectionStatusForSchemaBrowserQueryVariables =
  Types.Exact<{
    dataConnectionId: Types.Scalars["DataConnectionId"]["input"];
  }>;

export type GetDataConnectionStatusForSchemaBrowserQuery = {
  readonly __typename: "Query";
  readonly dataConnectionById: {
    readonly __typename: "DataConnection";
    readonly id: c.DataConnectionId;
    readonly status: string | null;
  };
};

export type DataSourceColumnByIdQueryVariables = Types.Exact<{
  dataSourceColumnId: Types.Scalars["DataSourceColumnId"]["input"];
}>;

export type DataSourceColumnByIdQuery = {
  readonly __typename: "Query";
  readonly dataSourceColumnById: {
    readonly __typename: "DataSourceColumn";
    readonly name: string;
    readonly sourceTableName: string | null;
    readonly id: c.DataSourceColumnId;
    readonly type: string;
    readonly dbtDescription: string | null;
    readonly dbtDescriptionMdStripped: string | null;
    readonly dbtTests: ReadonlyArray<c.DbtTestMetadata> | null;
    readonly comment: string | null;
    readonly metadata: {
      readonly __typename: "DataSourceColumnMetadata";
      readonly id: c.DataSourceColumnMetadataId;
      readonly magicDescription: string | null;
    } | null;
    readonly dataSourceTable: {
      readonly __typename: "DataSourceTable";
      readonly id: c.DataSourceTableId;
      readonly name: string;
      readonly dbtAccessUrl: string | null;
      readonly dbtRunId: string | null;
      readonly dbtUniqueId: string | null;
      readonly dbtProjectId: string | null;
      readonly dbtAccountId: string | null;
      readonly dataSourceSchema: {
        readonly __typename: "DataSourceSchema";
        readonly id: c.DataSourceSchemaId;
        readonly name: string;
        readonly dataSourceDatabase: {
          readonly __typename: "DataSourceDatabase";
          readonly id: c.DataSourceDatabaseId;
          readonly name: string | null;
        };
      };
    };
  };
};

export type DataSourceColumnFragment = {
  readonly __typename: "DataSourceColumn";
  readonly name: string;
  readonly sourceTableName: string | null;
  readonly id: c.DataSourceColumnId;
  readonly type: string;
  readonly displayTableColumnType: Types.DisplayTableColumnType | null;
  readonly columnSemanticLayerType: Types.ColumnSemanticLayerType | null;
  readonly dbtDescription: string | null;
  readonly dbtDescriptionMdStripped: string | null;
  readonly dbtTests: ReadonlyArray<c.DbtTestMetadata> | null;
  readonly comment: string | null;
  readonly metadata: {
    readonly __typename: "DataSourceColumnMetadata";
    readonly id: c.DataSourceColumnMetadataId;
    readonly magicDescription: string | null;
  } | null;
};

export type DataSourceTableByIdQueryVariables = Types.Exact<{
  dataSourceTableId: Types.Scalars["DataSourceTableId"]["input"];
}>;

export type DataSourceTableByIdQuery = {
  readonly __typename: "Query";
  readonly dataSourceTableById: {
    readonly __typename: "DataSourceTable";
    readonly name: string;
    readonly id: c.DataSourceTableId;
    readonly columnCount: number;
    readonly tableType: Types.TableType | null;
    readonly dbtAccessUrl: string | null;
    readonly dbtRunId: string | null;
    readonly dbtUniqueId: string | null;
    readonly dbtProjectId: string | null;
    readonly dbtAccountId: string | null;
    readonly dbtLastRefreshed: c.DateTimeString | null;
    readonly dbtTests: ReadonlyArray<c.DbtTestMetadata> | null;
    readonly dbtFreshness: string | null;
    readonly dbtMetadataError: boolean | null;
    readonly dbtWarnAfterCount: number | null;
    readonly dbtWarnAfterPeriod: string | null;
    readonly dbtErrorAfterCount: number | null;
    readonly dbtErrorAfterPeriod: string | null;
    readonly dbtDescription: string | null;
    readonly dbtDescriptionMdStripped: string | null;
    readonly comment: string | null;
    readonly dataSourceSchema: {
      readonly __typename: "DataSourceSchema";
      readonly id: c.DataSourceSchemaId;
      readonly name: string;
      readonly metadata: {
        readonly __typename: "DataSourceSchemaMetadata";
        readonly id: c.DataSourceSchemaMetadataId;
        readonly status: {
          readonly __typename: "Status";
          readonly id: c.StatusId;
          readonly name: string;
          readonly color: Types.HexColor;
          readonly description: string | null;
          readonly inLibrary: boolean;
          readonly endorsed: boolean;
          readonly icon: Types.IconType | null;
        } | null;
      } | null;
      readonly dataSourceDatabase: {
        readonly __typename: "DataSourceDatabase";
        readonly id: c.DataSourceDatabaseId;
        readonly name: string | null;
        readonly metadata: {
          readonly __typename: "DataSourceDatabaseMetadata";
          readonly id: c.DataSourceDatabaseMetadataId;
          readonly status: {
            readonly __typename: "Status";
            readonly id: c.StatusId;
            readonly name: string;
            readonly color: Types.HexColor;
            readonly description: string | null;
            readonly inLibrary: boolean;
            readonly endorsed: boolean;
            readonly icon: Types.IconType | null;
          } | null;
        } | null;
      };
    };
    readonly metadata: {
      readonly __typename: "DataSourceTableMetadata";
      readonly id: c.DataSourceTableMetadataId;
      readonly magicDescription: string | null;
      readonly status: {
        readonly __typename: "Status";
        readonly id: c.StatusId;
        readonly name: string;
        readonly color: Types.HexColor;
        readonly description: string | null;
        readonly inLibrary: boolean;
        readonly endorsed: boolean;
        readonly icon: Types.IconType | null;
      } | null;
      readonly categories: ReadonlyArray<{
        readonly __typename: "Category";
        readonly id: c.CategoryId;
        readonly name: string;
        readonly color: Types.HexColor;
        readonly description: string | null;
      }>;
    } | null;
    readonly columns: ReadonlyArray<{
      readonly __typename: "DataSourceColumn";
      readonly id: c.DataSourceColumnId;
      readonly name: string;
      readonly sourceTableName: string | null;
      readonly type: string;
      readonly displayTableColumnType: Types.DisplayTableColumnType | null;
      readonly columnSemanticLayerType: Types.ColumnSemanticLayerType | null;
      readonly dbtDescription: string | null;
      readonly dbtDescriptionMdStripped: string | null;
      readonly dbtTests: ReadonlyArray<c.DbtTestMetadata> | null;
      readonly comment: string | null;
      readonly metadata: {
        readonly __typename: "DataSourceColumnMetadata";
        readonly id: c.DataSourceColumnMetadataId;
        readonly magicDescription: string | null;
      } | null;
    }>;
  };
};

export type DataConnectionWithDatabasesByIdQueryVariables = Types.Exact<{
  dataConnectionId: Types.Scalars["DataConnectionId"]["input"];
  appSessionId: Types.InputMaybe<Types.Scalars["AppSessionId"]["input"]>;
  databaseLimit: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  schemaLimit: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
}>;

export type DataConnectionWithDatabasesByIdQuery = {
  readonly __typename: "Query";
  readonly dataConnectionById: {
    readonly __typename: "DataConnection";
    readonly id: c.DataConnectionId;
    readonly connectionName: string;
    readonly lastRefreshed: c.DateTimeString | null;
    readonly status: string | null;
    readonly databaseCount: number;
    readonly magicUsageStatus: Types.MagicUsageStatus;
    readonly oauthSchemasApplied: boolean;
    readonly databases: ReadonlyArray<{
      readonly __typename: "DataSourceDatabase";
      readonly id: c.DataSourceDatabaseId;
      readonly name: string | null;
      readonly schemaCount: number;
      readonly pinned: boolean;
      readonly metadata: {
        readonly __typename: "DataSourceDatabaseMetadata";
        readonly id: c.DataSourceDatabaseMetadataId;
        readonly magicDescription: string | null;
        readonly status: {
          readonly __typename: "Status";
          readonly id: c.StatusId;
          readonly name: string;
          readonly color: Types.HexColor;
          readonly description: string | null;
          readonly inLibrary: boolean;
          readonly endorsed: boolean;
          readonly icon: Types.IconType | null;
        } | null;
        readonly categories: ReadonlyArray<{
          readonly __typename: "Category";
          readonly id: c.CategoryId;
          readonly name: string;
          readonly color: Types.HexColor;
          readonly description: string | null;
        }>;
      } | null;
      readonly schemas: ReadonlyArray<{
        readonly __typename: "DataSourceSchema";
        readonly id: c.DataSourceSchemaId;
        readonly name: string;
        readonly pinned: boolean;
        readonly pinnedAt: c.DateTimeString | null;
        readonly metadata: {
          readonly __typename: "DataSourceSchemaMetadata";
          readonly id: c.DataSourceSchemaMetadataId;
          readonly magicDescription: string | null;
          readonly status: {
            readonly __typename: "Status";
            readonly id: c.StatusId;
            readonly name: string;
            readonly color: Types.HexColor;
            readonly description: string | null;
            readonly inLibrary: boolean;
            readonly endorsed: boolean;
            readonly icon: Types.IconType | null;
          } | null;
          readonly categories: ReadonlyArray<{
            readonly __typename: "Category";
            readonly id: c.CategoryId;
            readonly name: string;
            readonly color: Types.HexColor;
            readonly description: string | null;
          }>;
        } | null;
      }>;
    }>;
  };
};

export type DataSourceSchemaTablesQueryVariables = Types.Exact<{
  dataSourceSchemaId: Types.Scalars["DataSourceSchemaId"]["input"];
  appSessionId: Types.InputMaybe<Types.Scalars["AppSessionId"]["input"]>;
  first: Types.Scalars["Int"]["input"];
  after: Types.InputMaybe<Types.Scalars["Cursor"]["input"]>;
}>;

export type DataSourceSchemaTablesQuery = {
  readonly __typename: "Query";
  readonly dataSourceSchemaById: {
    readonly __typename: "DataSourceSchema";
    readonly id: c.DataSourceSchemaId;
    readonly name: string;
    readonly tableCount: number;
    readonly dataSourceDatabase: {
      readonly __typename: "DataSourceDatabase";
      readonly id: c.DataSourceDatabaseId;
      readonly name: string | null;
    };
    readonly tables: {
      readonly __typename: "TablesConnection";
      readonly pageInfo: {
        readonly __typename: "PageInfo";
        readonly hasNextPage: boolean;
        readonly endCursor: c.Cursor | null;
      };
      readonly edges: ReadonlyArray<{
        readonly __typename: "TablesEdge";
        readonly node: {
          readonly __typename: "DataSourceTable";
          readonly id: c.DataSourceTableId;
          readonly name: string;
          readonly comment: string | null;
          readonly columnCount: number;
          readonly dataConnectionId: c.DataConnectionId;
          readonly tableType: Types.TableType | null;
          readonly dbtDescriptionMdStripped: string | null;
          readonly pinned: boolean;
          readonly pinnedAt: c.DateTimeString | null;
          readonly metadata: {
            readonly __typename: "DataSourceTableMetadata";
            readonly id: c.DataSourceTableMetadataId;
            readonly magicDescription: string | null;
            readonly status: {
              readonly __typename: "Status";
              readonly id: c.StatusId;
              readonly name: string;
              readonly color: Types.HexColor;
              readonly description: string | null;
              readonly inLibrary: boolean;
              readonly endorsed: boolean;
              readonly icon: Types.IconType | null;
            } | null;
            readonly categories: ReadonlyArray<{
              readonly __typename: "Category";
              readonly id: c.CategoryId;
              readonly name: string;
              readonly color: Types.HexColor;
              readonly description: string | null;
            }>;
          } | null;
          readonly dataSourceSchema: {
            readonly __typename: "DataSourceSchema";
            readonly id: c.DataSourceSchemaId;
            readonly name: string;
            readonly dataSourceDatabase: {
              readonly __typename: "DataSourceDatabase";
              readonly id: c.DataSourceDatabaseId;
              readonly name: string | null;
            };
          };
        };
      }>;
    };
  };
};

export type PinSchemaMutationVariables = Types.Exact<{
  dataConnectionId: Types.Scalars["DataConnectionId"]["input"];
  dataSourceSchemaId: Types.Scalars["DataSourceSchemaId"]["input"];
  pinned: Types.Scalars["Boolean"]["input"];
}>;

export type PinSchemaMutation = {
  readonly __typename: "Mutation";
  readonly pinSchema: {
    readonly __typename: "DataSourceSchema";
    readonly id: c.DataSourceSchemaId;
    readonly pinned: boolean;
    readonly pinnedAt: c.DateTimeString | null;
    readonly name: string;
    readonly dataConnectionId: c.DataConnectionId;
    readonly tableCount: number;
    readonly metadata: {
      readonly __typename: "DataSourceSchemaMetadata";
      readonly id: c.DataSourceSchemaMetadataId;
      readonly magicDescription: string | null;
      readonly status: {
        readonly __typename: "Status";
        readonly id: c.StatusId;
        readonly name: string;
        readonly color: Types.HexColor;
        readonly description: string | null;
        readonly inLibrary: boolean;
        readonly endorsed: boolean;
        readonly icon: Types.IconType | null;
      } | null;
      readonly categories: ReadonlyArray<{
        readonly __typename: "Category";
        readonly id: c.CategoryId;
        readonly name: string;
        readonly color: Types.HexColor;
        readonly description: string | null;
      }>;
    } | null;
    readonly dataSourceDatabase: {
      readonly __typename: "DataSourceDatabase";
      readonly id: c.DataSourceDatabaseId;
      readonly name: string | null;
    };
  };
};

export type PinTableMutationVariables = Types.Exact<{
  dataConnectionId: Types.Scalars["DataConnectionId"]["input"];
  dataSourceTableId: Types.Scalars["DataSourceTableId"]["input"];
  pinned: Types.Scalars["Boolean"]["input"];
}>;

export type PinTableMutation = {
  readonly __typename: "Mutation";
  readonly pinTable: {
    readonly __typename: "DataSourceTable";
    readonly id: c.DataSourceTableId;
    readonly name: string;
    readonly comment: string | null;
    readonly columnCount: number;
    readonly dataConnectionId: c.DataConnectionId;
    readonly tableType: Types.TableType | null;
    readonly dbtDescriptionMdStripped: string | null;
    readonly pinned: boolean;
    readonly pinnedAt: c.DateTimeString | null;
    readonly metadata: {
      readonly __typename: "DataSourceTableMetadata";
      readonly id: c.DataSourceTableMetadataId;
      readonly magicDescription: string | null;
      readonly status: {
        readonly __typename: "Status";
        readonly id: c.StatusId;
        readonly name: string;
        readonly color: Types.HexColor;
        readonly description: string | null;
        readonly inLibrary: boolean;
        readonly endorsed: boolean;
        readonly icon: Types.IconType | null;
      } | null;
      readonly categories: ReadonlyArray<{
        readonly __typename: "Category";
        readonly id: c.CategoryId;
        readonly name: string;
        readonly color: Types.HexColor;
        readonly description: string | null;
      }>;
    } | null;
    readonly dataSourceSchema: {
      readonly __typename: "DataSourceSchema";
      readonly id: c.DataSourceSchemaId;
      readonly name: string;
      readonly dataSourceDatabase: {
        readonly __typename: "DataSourceDatabase";
        readonly id: c.DataSourceDatabaseId;
        readonly name: string | null;
      };
    };
  };
};

export type ObjectPinnedSubscriptionVariables = Types.Exact<{
  dataConnectionId: Types.Scalars["DataConnectionId"]["input"];
  userId: Types.Scalars["UserId"]["input"];
}>;

export type ObjectPinnedSubscription = {
  readonly __typename: "Subscription";
  readonly dataSourceObjectPinned: {
    readonly __typename: "PinnedObjectResponse";
    readonly databases: ReadonlyArray<{
      readonly __typename: "DataSourceDatabase";
      readonly id: c.DataSourceDatabaseId;
      readonly pinned: boolean;
    }>;
    readonly schemas: ReadonlyArray<{
      readonly __typename: "DataSourceSchema";
      readonly id: c.DataSourceSchemaId;
      readonly pinned: boolean;
      readonly dataSourceDatabase: {
        readonly __typename: "DataSourceDatabase";
        readonly id: c.DataSourceDatabaseId;
      };
    }>;
    readonly tables: ReadonlyArray<{
      readonly __typename: "DataSourceTable";
      readonly id: c.DataSourceTableId;
      readonly pinned: boolean;
      readonly dataSourceSchema: {
        readonly __typename: "DataSourceSchema";
        readonly id: c.DataSourceSchemaId;
        readonly dataSourceDatabase: {
          readonly __typename: "DataSourceDatabase";
          readonly id: c.DataSourceDatabaseId;
        };
      };
    }>;
  };
};

export type DataSourceDatabaseResultFragment = {
  readonly __typename: "DataSourceDatabase";
  readonly name: string | null;
  readonly id: c.DataSourceDatabaseId;
  readonly dataConnectionId: c.DataConnectionId;
  readonly metadata: {
    readonly __typename: "DataSourceDatabaseMetadata";
    readonly id: c.DataSourceDatabaseMetadataId;
    readonly status: {
      readonly __typename: "Status";
      readonly id: c.StatusId;
      readonly name: string;
      readonly color: Types.HexColor;
      readonly description: string | null;
      readonly inLibrary: boolean;
      readonly endorsed: boolean;
      readonly icon: Types.IconType | null;
    } | null;
  } | null;
};

export type DataSourceSchemaResultFragment = {
  readonly __typename: "DataSourceSchema";
  readonly name: string;
  readonly id: c.DataSourceSchemaId;
  readonly metadata: {
    readonly __typename: "DataSourceSchemaMetadata";
    readonly id: c.DataSourceSchemaMetadataId;
    readonly status: {
      readonly __typename: "Status";
      readonly id: c.StatusId;
      readonly name: string;
      readonly color: Types.HexColor;
      readonly description: string | null;
      readonly inLibrary: boolean;
      readonly endorsed: boolean;
      readonly icon: Types.IconType | null;
    } | null;
  } | null;
  readonly dataSourceDatabase: {
    readonly __typename: "DataSourceDatabase";
    readonly name: string | null;
    readonly id: c.DataSourceDatabaseId;
    readonly dataConnectionId: c.DataConnectionId;
    readonly metadata: {
      readonly __typename: "DataSourceDatabaseMetadata";
      readonly id: c.DataSourceDatabaseMetadataId;
      readonly status: {
        readonly __typename: "Status";
        readonly id: c.StatusId;
        readonly name: string;
        readonly color: Types.HexColor;
        readonly description: string | null;
        readonly inLibrary: boolean;
        readonly endorsed: boolean;
        readonly icon: Types.IconType | null;
      } | null;
    } | null;
  };
};

export type DataSourceTableResultFragment = {
  readonly __typename: "DataSourceTable";
  readonly name: string;
  readonly id: c.DataSourceTableId;
  readonly pinned: boolean;
  readonly dbtDescription: string | null;
  readonly comment: string | null;
  readonly metadata: {
    readonly __typename: "DataSourceTableMetadata";
    readonly id: c.DataSourceTableMetadataId;
    readonly magicDescription: string | null;
    readonly status: {
      readonly __typename: "Status";
      readonly id: c.StatusId;
      readonly name: string;
      readonly color: Types.HexColor;
      readonly description: string | null;
      readonly inLibrary: boolean;
      readonly endorsed: boolean;
      readonly icon: Types.IconType | null;
    } | null;
  } | null;
  readonly dataSourceSchema: {
    readonly __typename: "DataSourceSchema";
    readonly name: string;
    readonly id: c.DataSourceSchemaId;
    readonly metadata: {
      readonly __typename: "DataSourceSchemaMetadata";
      readonly id: c.DataSourceSchemaMetadataId;
      readonly status: {
        readonly __typename: "Status";
        readonly id: c.StatusId;
        readonly name: string;
        readonly color: Types.HexColor;
        readonly description: string | null;
        readonly inLibrary: boolean;
        readonly endorsed: boolean;
        readonly icon: Types.IconType | null;
      } | null;
    } | null;
    readonly dataSourceDatabase: {
      readonly __typename: "DataSourceDatabase";
      readonly name: string | null;
      readonly id: c.DataSourceDatabaseId;
      readonly dataConnectionId: c.DataConnectionId;
      readonly metadata: {
        readonly __typename: "DataSourceDatabaseMetadata";
        readonly id: c.DataSourceDatabaseMetadataId;
        readonly status: {
          readonly __typename: "Status";
          readonly id: c.StatusId;
          readonly name: string;
          readonly color: Types.HexColor;
          readonly description: string | null;
          readonly inLibrary: boolean;
          readonly endorsed: boolean;
          readonly icon: Types.IconType | null;
        } | null;
      } | null;
    };
  };
};

export type DataSourceColumnResultFragment = {
  readonly __typename: "DataSourceColumn";
  readonly name: string;
  readonly id: c.DataSourceColumnId;
  readonly type: string;
  readonly dataSourceTable: {
    readonly __typename: "DataSourceTable";
    readonly name: string;
    readonly id: c.DataSourceTableId;
    readonly pinned: boolean;
    readonly dbtDescription: string | null;
    readonly comment: string | null;
    readonly metadata: {
      readonly __typename: "DataSourceTableMetadata";
      readonly id: c.DataSourceTableMetadataId;
      readonly magicDescription: string | null;
      readonly status: {
        readonly __typename: "Status";
        readonly id: c.StatusId;
        readonly name: string;
        readonly color: Types.HexColor;
        readonly description: string | null;
        readonly inLibrary: boolean;
        readonly endorsed: boolean;
        readonly icon: Types.IconType | null;
      } | null;
    } | null;
    readonly dataSourceSchema: {
      readonly __typename: "DataSourceSchema";
      readonly name: string;
      readonly id: c.DataSourceSchemaId;
      readonly metadata: {
        readonly __typename: "DataSourceSchemaMetadata";
        readonly id: c.DataSourceSchemaMetadataId;
        readonly status: {
          readonly __typename: "Status";
          readonly id: c.StatusId;
          readonly name: string;
          readonly color: Types.HexColor;
          readonly description: string | null;
          readonly inLibrary: boolean;
          readonly endorsed: boolean;
          readonly icon: Types.IconType | null;
        } | null;
      } | null;
      readonly dataSourceDatabase: {
        readonly __typename: "DataSourceDatabase";
        readonly name: string | null;
        readonly id: c.DataSourceDatabaseId;
        readonly dataConnectionId: c.DataConnectionId;
        readonly metadata: {
          readonly __typename: "DataSourceDatabaseMetadata";
          readonly id: c.DataSourceDatabaseMetadataId;
          readonly status: {
            readonly __typename: "Status";
            readonly id: c.StatusId;
            readonly name: string;
            readonly color: Types.HexColor;
            readonly description: string | null;
            readonly inLibrary: boolean;
            readonly endorsed: boolean;
            readonly icon: Types.IconType | null;
          } | null;
        } | null;
      };
    };
  };
};

export type SearchSchemaElementsQueryVariables = Types.Exact<{
  dataConnectionId:
    | ReadonlyArray<Types.Scalars["DataConnectionId"]["input"]>
    | Types.Scalars["DataConnectionId"]["input"];
  searchQuery: Types.Scalars["String"]["input"];
  schemaFilters: Types.InputMaybe<
    | ReadonlyArray<Types.SchemaElementSearchSchemaFilter>
    | Types.SchemaElementSearchSchemaFilter
  >;
  tableFilters: Types.InputMaybe<
    | ReadonlyArray<Types.SchemaElementSearchTableFilter>
    | Types.SchemaElementSearchTableFilter
  >;
  columnFilters: Types.InputMaybe<
    | ReadonlyArray<Types.SchemaElementSearchColumnFilter>
    | Types.SchemaElementSearchColumnFilter
  >;
  resultTypes: Types.InputMaybe<
    | ReadonlyArray<Types.SchemaElementSearchResultType>
    | Types.SchemaElementSearchResultType
  >;
  pinnedOnly: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  limit: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
}>;

export type SearchSchemaElementsQuery = {
  readonly __typename: "Query";
  readonly searchSchemaElements: {
    readonly __typename: "SchemaElementSearchResults";
    readonly databases: {
      readonly __typename: "DatabaseSearchResults";
      readonly databaseSearchResults: ReadonlyArray<{
        readonly __typename: "DataSourceDatabase";
        readonly name: string | null;
        readonly id: c.DataSourceDatabaseId;
        readonly dataConnectionId: c.DataConnectionId;
        readonly metadata: {
          readonly __typename: "DataSourceDatabaseMetadata";
          readonly id: c.DataSourceDatabaseMetadataId;
          readonly status: {
            readonly __typename: "Status";
            readonly id: c.StatusId;
            readonly name: string;
            readonly color: Types.HexColor;
            readonly description: string | null;
            readonly inLibrary: boolean;
            readonly endorsed: boolean;
            readonly icon: Types.IconType | null;
          } | null;
        } | null;
      }>;
    };
    readonly schemas: {
      readonly __typename: "SchemaSearchResults";
      readonly schemaSearchResults: ReadonlyArray<{
        readonly __typename: "DataSourceSchema";
        readonly name: string;
        readonly id: c.DataSourceSchemaId;
        readonly metadata: {
          readonly __typename: "DataSourceSchemaMetadata";
          readonly id: c.DataSourceSchemaMetadataId;
          readonly status: {
            readonly __typename: "Status";
            readonly id: c.StatusId;
            readonly name: string;
            readonly color: Types.HexColor;
            readonly description: string | null;
            readonly inLibrary: boolean;
            readonly endorsed: boolean;
            readonly icon: Types.IconType | null;
          } | null;
        } | null;
        readonly dataSourceDatabase: {
          readonly __typename: "DataSourceDatabase";
          readonly name: string | null;
          readonly id: c.DataSourceDatabaseId;
          readonly dataConnectionId: c.DataConnectionId;
          readonly metadata: {
            readonly __typename: "DataSourceDatabaseMetadata";
            readonly id: c.DataSourceDatabaseMetadataId;
            readonly status: {
              readonly __typename: "Status";
              readonly id: c.StatusId;
              readonly name: string;
              readonly color: Types.HexColor;
              readonly description: string | null;
              readonly inLibrary: boolean;
              readonly endorsed: boolean;
              readonly icon: Types.IconType | null;
            } | null;
          } | null;
        };
      }>;
    };
    readonly tables: {
      readonly __typename: "TableSearchResults";
      readonly tableSearchResults: ReadonlyArray<{
        readonly __typename: "DataSourceTable";
        readonly name: string;
        readonly id: c.DataSourceTableId;
        readonly pinned: boolean;
        readonly dbtDescription: string | null;
        readonly comment: string | null;
        readonly metadata: {
          readonly __typename: "DataSourceTableMetadata";
          readonly id: c.DataSourceTableMetadataId;
          readonly magicDescription: string | null;
          readonly status: {
            readonly __typename: "Status";
            readonly id: c.StatusId;
            readonly name: string;
            readonly color: Types.HexColor;
            readonly description: string | null;
            readonly inLibrary: boolean;
            readonly endorsed: boolean;
            readonly icon: Types.IconType | null;
          } | null;
        } | null;
        readonly dataSourceSchema: {
          readonly __typename: "DataSourceSchema";
          readonly name: string;
          readonly id: c.DataSourceSchemaId;
          readonly metadata: {
            readonly __typename: "DataSourceSchemaMetadata";
            readonly id: c.DataSourceSchemaMetadataId;
            readonly status: {
              readonly __typename: "Status";
              readonly id: c.StatusId;
              readonly name: string;
              readonly color: Types.HexColor;
              readonly description: string | null;
              readonly inLibrary: boolean;
              readonly endorsed: boolean;
              readonly icon: Types.IconType | null;
            } | null;
          } | null;
          readonly dataSourceDatabase: {
            readonly __typename: "DataSourceDatabase";
            readonly name: string | null;
            readonly id: c.DataSourceDatabaseId;
            readonly dataConnectionId: c.DataConnectionId;
            readonly metadata: {
              readonly __typename: "DataSourceDatabaseMetadata";
              readonly id: c.DataSourceDatabaseMetadataId;
              readonly status: {
                readonly __typename: "Status";
                readonly id: c.StatusId;
                readonly name: string;
                readonly color: Types.HexColor;
                readonly description: string | null;
                readonly inLibrary: boolean;
                readonly endorsed: boolean;
                readonly icon: Types.IconType | null;
              } | null;
            } | null;
          };
        };
      }>;
    };
    readonly columns: {
      readonly __typename: "ColumnSearchResults";
      readonly columnSearchResults: ReadonlyArray<{
        readonly __typename: "DataSourceColumn";
        readonly name: string;
        readonly id: c.DataSourceColumnId;
        readonly type: string;
        readonly dataSourceTable: {
          readonly __typename: "DataSourceTable";
          readonly name: string;
          readonly id: c.DataSourceTableId;
          readonly pinned: boolean;
          readonly dbtDescription: string | null;
          readonly comment: string | null;
          readonly metadata: {
            readonly __typename: "DataSourceTableMetadata";
            readonly id: c.DataSourceTableMetadataId;
            readonly magicDescription: string | null;
            readonly status: {
              readonly __typename: "Status";
              readonly id: c.StatusId;
              readonly name: string;
              readonly color: Types.HexColor;
              readonly description: string | null;
              readonly inLibrary: boolean;
              readonly endorsed: boolean;
              readonly icon: Types.IconType | null;
            } | null;
          } | null;
          readonly dataSourceSchema: {
            readonly __typename: "DataSourceSchema";
            readonly name: string;
            readonly id: c.DataSourceSchemaId;
            readonly metadata: {
              readonly __typename: "DataSourceSchemaMetadata";
              readonly id: c.DataSourceSchemaMetadataId;
              readonly status: {
                readonly __typename: "Status";
                readonly id: c.StatusId;
                readonly name: string;
                readonly color: Types.HexColor;
                readonly description: string | null;
                readonly inLibrary: boolean;
                readonly endorsed: boolean;
                readonly icon: Types.IconType | null;
              } | null;
            } | null;
            readonly dataSourceDatabase: {
              readonly __typename: "DataSourceDatabase";
              readonly name: string | null;
              readonly id: c.DataSourceDatabaseId;
              readonly dataConnectionId: c.DataConnectionId;
              readonly metadata: {
                readonly __typename: "DataSourceDatabaseMetadata";
                readonly id: c.DataSourceDatabaseMetadataId;
                readonly status: {
                  readonly __typename: "Status";
                  readonly id: c.StatusId;
                  readonly name: string;
                  readonly color: Types.HexColor;
                  readonly description: string | null;
                  readonly inLibrary: boolean;
                  readonly endorsed: boolean;
                  readonly icon: Types.IconType | null;
                } | null;
              } | null;
            };
          };
        };
      }>;
    };
  };
};

export type PinSemanticDatasetMutationVariables = Types.Exact<{
  semanticDatasetId: Types.Scalars["SemanticDatasetId"]["input"];
  pinned: Types.Scalars["Boolean"]["input"];
}>;

export type PinSemanticDatasetMutation = {
  readonly __typename: "Mutation";
  readonly pinSemanticDataset: {
    readonly __typename: "SemanticDataset";
    readonly id: c.SemanticDatasetId;
    readonly pinned: boolean;
    readonly pinnedAt: c.DateTimeString | null;
    readonly name: c.SemanticDatasetName;
    readonly title: string | null;
    readonly description: string | null;
    readonly status: {
      readonly __typename: "Status";
      readonly id: c.StatusId;
    } | null;
    readonly categories: ReadonlyArray<{
      readonly __typename: "Category";
      readonly id: c.CategoryId;
    }>;
    readonly semanticProject: {
      readonly __typename: "SemanticProject";
      readonly id: c.SemanticProjectId;
      readonly name: string;
      readonly dataConnection: {
        readonly __typename: "DataConnection";
        readonly id: c.DataConnectionId;
      } | null;
    };
  };
};

export const DataSourceColumnFragmentDoc = /*#__PURE__*/ gql`
  fragment DataSourceColumnFragment on DataSourceColumn {
    name
    sourceTableName
    id
    type
    displayTableColumnType
    columnSemanticLayerType
    dbtDescription
    dbtDescriptionMdStripped
    dbtTests
    comment
    metadata {
      id
      magicDescription
    }
  }
`;
export const DataSourceDatabaseResultFragmentDoc = /*#__PURE__*/ gql`
  fragment DataSourceDatabaseResultFragment on DataSourceDatabase {
    name
    id
    dataConnectionId
    metadata {
      id
      status {
        ...StatusFragment
      }
    }
  }
  ${StatusFragmentDoc}
`;
export const DataSourceSchemaResultFragmentDoc = /*#__PURE__*/ gql`
  fragment DataSourceSchemaResultFragment on DataSourceSchema {
    name
    id
    metadata {
      id
      status {
        ...StatusFragment
      }
    }
    dataSourceDatabase {
      ...DataSourceDatabaseResultFragment
    }
  }
  ${StatusFragmentDoc}
  ${DataSourceDatabaseResultFragmentDoc}
`;
export const DataSourceTableResultFragmentDoc = /*#__PURE__*/ gql`
  fragment DataSourceTableResultFragment on DataSourceTable {
    name
    id
    pinned
    dbtDescription
    comment
    metadata {
      id
      magicDescription
      status {
        ...StatusFragment
      }
    }
    dataSourceSchema {
      ...DataSourceSchemaResultFragment
    }
  }
  ${StatusFragmentDoc}
  ${DataSourceSchemaResultFragmentDoc}
`;
export const DataSourceColumnResultFragmentDoc = /*#__PURE__*/ gql`
  fragment DataSourceColumnResultFragment on DataSourceColumn {
    name
    id
    type
    dataSourceTable {
      ...DataSourceTableResultFragment
    }
  }
  ${DataSourceTableResultFragmentDoc}
`;
export const RefreshSchemaDocument = /*#__PURE__*/ gql`
  mutation RefreshSchema(
    $dataConnectionId: DataConnectionId!
    $appSessionId: AppSessionId = null
  ) {
    refreshDataConnectionSchema(dataConnectionId: $dataConnectionId) {
      ...DataConnectionItemFragment
    }
  }
  ${DataConnectionItemFragmentDoc}
`;
export type RefreshSchemaMutationFn = Apollo.MutationFunction<
  RefreshSchemaMutation,
  RefreshSchemaMutationVariables
>;

/**
 * __useRefreshSchemaMutation__
 *
 * To run a mutation, you first call `useRefreshSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshSchemaMutation, { data, loading, error }] = useRefreshSchemaMutation({
 *   variables: {
 *      dataConnectionId: // value for 'dataConnectionId'
 *      appSessionId: // value for 'appSessionId'
 *   },
 * });
 */
export function useRefreshSchemaMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RefreshSchemaMutation,
    RefreshSchemaMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RefreshSchemaMutation,
    RefreshSchemaMutationVariables
  >(RefreshSchemaDocument, options);
}
export type RefreshSchemaMutationHookResult = ReturnType<
  typeof useRefreshSchemaMutation
>;
export type RefreshSchemaMutationResult =
  Apollo.MutationResult<RefreshSchemaMutation>;
export type RefreshSchemaMutationOptions = Apollo.BaseMutationOptions<
  RefreshSchemaMutation,
  RefreshSchemaMutationVariables
>;
export const DataConnectionRefreshProgressDocument = /*#__PURE__*/ gql`
  subscription DataConnectionRefreshProgress(
    $dataConnectionId: DataConnectionId!
  ) {
    dataConnectionRefreshProgress(dataConnectionId: $dataConnectionId) {
      dataConnectionId
      currentProgress
      finishedProgress
      section
    }
  }
`;

/**
 * __useDataConnectionRefreshProgressSubscription__
 *
 * To run a query within a React component, call `useDataConnectionRefreshProgressSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDataConnectionRefreshProgressSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataConnectionRefreshProgressSubscription({
 *   variables: {
 *      dataConnectionId: // value for 'dataConnectionId'
 *   },
 * });
 */
export function useDataConnectionRefreshProgressSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    DataConnectionRefreshProgressSubscription,
    DataConnectionRefreshProgressSubscriptionVariables
  > &
    (
      | {
          variables: DataConnectionRefreshProgressSubscriptionVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    DataConnectionRefreshProgressSubscription,
    DataConnectionRefreshProgressSubscriptionVariables
  >(DataConnectionRefreshProgressDocument, options);
}
export type DataConnectionRefreshProgressSubscriptionHookResult = ReturnType<
  typeof useDataConnectionRefreshProgressSubscription
>;
export type DataConnectionRefreshProgressSubscriptionResult =
  Apollo.SubscriptionResult<DataConnectionRefreshProgressSubscription>;
export const DataConnectionRefreshDocument = /*#__PURE__*/ gql`
  subscription DataConnectionRefresh($dataConnectionId: DataConnectionId!) {
    dataConnectionRefresh(dataConnectionId: $dataConnectionId) {
      id
      status
      lastRefreshed
      dbtErrorMessages
      dbtMetadataError
      dbtMetadataErrorMessages
      hasDbtMetadata
      dbtMetricsError
      dbtMetricsErrorMessages
      hasDbtMetrics
      databases {
        id
        name
      }
    }
  }
`;

/**
 * __useDataConnectionRefreshSubscription__
 *
 * To run a query within a React component, call `useDataConnectionRefreshSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDataConnectionRefreshSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataConnectionRefreshSubscription({
 *   variables: {
 *      dataConnectionId: // value for 'dataConnectionId'
 *   },
 * });
 */
export function useDataConnectionRefreshSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    DataConnectionRefreshSubscription,
    DataConnectionRefreshSubscriptionVariables
  > &
    (
      | {
          variables: DataConnectionRefreshSubscriptionVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    DataConnectionRefreshSubscription,
    DataConnectionRefreshSubscriptionVariables
  >(DataConnectionRefreshDocument, options);
}
export type DataConnectionRefreshSubscriptionHookResult = ReturnType<
  typeof useDataConnectionRefreshSubscription
>;
export type DataConnectionRefreshSubscriptionResult =
  Apollo.SubscriptionResult<DataConnectionRefreshSubscription>;
export const DataConnectionOAuthMigrationProgressDocument = /*#__PURE__*/ gql`
  subscription DataConnectionOAuthMigrationProgress(
    $dataConnectionId: DataConnectionId!
  ) {
    dataConnectionOAuthMigrationProgress(dataConnectionId: $dataConnectionId) {
      dataConnectionId
      currentProgress
      totalProgress
      status
    }
  }
`;

/**
 * __useDataConnectionOAuthMigrationProgressSubscription__
 *
 * To run a query within a React component, call `useDataConnectionOAuthMigrationProgressSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDataConnectionOAuthMigrationProgressSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataConnectionOAuthMigrationProgressSubscription({
 *   variables: {
 *      dataConnectionId: // value for 'dataConnectionId'
 *   },
 * });
 */
export function useDataConnectionOAuthMigrationProgressSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    DataConnectionOAuthMigrationProgressSubscription,
    DataConnectionOAuthMigrationProgressSubscriptionVariables
  > &
    (
      | {
          variables: DataConnectionOAuthMigrationProgressSubscriptionVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    DataConnectionOAuthMigrationProgressSubscription,
    DataConnectionOAuthMigrationProgressSubscriptionVariables
  >(DataConnectionOAuthMigrationProgressDocument, options);
}
export type DataConnectionOAuthMigrationProgressSubscriptionHookResult =
  ReturnType<typeof useDataConnectionOAuthMigrationProgressSubscription>;
export type DataConnectionOAuthMigrationProgressSubscriptionResult =
  Apollo.SubscriptionResult<DataConnectionOAuthMigrationProgressSubscription>;
export const GetDataConnectionStatusForSchemaBrowserDocument = /*#__PURE__*/ gql`
  query GetDataConnectionStatusForSchemaBrowser(
    $dataConnectionId: DataConnectionId!
  ) {
    dataConnectionById(dataConnectionId: $dataConnectionId) {
      id
      status
    }
  }
`;

/**
 * __useGetDataConnectionStatusForSchemaBrowserQuery__
 *
 * To run a query within a React component, call `useGetDataConnectionStatusForSchemaBrowserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataConnectionStatusForSchemaBrowserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataConnectionStatusForSchemaBrowserQuery({
 *   variables: {
 *      dataConnectionId: // value for 'dataConnectionId'
 *   },
 * });
 */
export function useGetDataConnectionStatusForSchemaBrowserQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDataConnectionStatusForSchemaBrowserQuery,
    GetDataConnectionStatusForSchemaBrowserQueryVariables
  > &
    (
      | {
          variables: GetDataConnectionStatusForSchemaBrowserQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDataConnectionStatusForSchemaBrowserQuery,
    GetDataConnectionStatusForSchemaBrowserQueryVariables
  >(GetDataConnectionStatusForSchemaBrowserDocument, options);
}
export function useGetDataConnectionStatusForSchemaBrowserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDataConnectionStatusForSchemaBrowserQuery,
    GetDataConnectionStatusForSchemaBrowserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDataConnectionStatusForSchemaBrowserQuery,
    GetDataConnectionStatusForSchemaBrowserQueryVariables
  >(GetDataConnectionStatusForSchemaBrowserDocument, options);
}
// @ts-ignore
export function useGetDataConnectionStatusForSchemaBrowserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDataConnectionStatusForSchemaBrowserQuery,
    GetDataConnectionStatusForSchemaBrowserQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetDataConnectionStatusForSchemaBrowserQuery,
  GetDataConnectionStatusForSchemaBrowserQueryVariables
>;
export function useGetDataConnectionStatusForSchemaBrowserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDataConnectionStatusForSchemaBrowserQuery,
        GetDataConnectionStatusForSchemaBrowserQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetDataConnectionStatusForSchemaBrowserQuery | undefined,
  GetDataConnectionStatusForSchemaBrowserQueryVariables
>;
export function useGetDataConnectionStatusForSchemaBrowserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDataConnectionStatusForSchemaBrowserQuery,
        GetDataConnectionStatusForSchemaBrowserQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDataConnectionStatusForSchemaBrowserQuery,
    GetDataConnectionStatusForSchemaBrowserQueryVariables
  >(GetDataConnectionStatusForSchemaBrowserDocument, options);
}
export type GetDataConnectionStatusForSchemaBrowserQueryHookResult = ReturnType<
  typeof useGetDataConnectionStatusForSchemaBrowserQuery
>;
export type GetDataConnectionStatusForSchemaBrowserLazyQueryHookResult =
  ReturnType<typeof useGetDataConnectionStatusForSchemaBrowserLazyQuery>;
export type GetDataConnectionStatusForSchemaBrowserSuspenseQueryHookResult =
  ReturnType<typeof useGetDataConnectionStatusForSchemaBrowserSuspenseQuery>;
export type GetDataConnectionStatusForSchemaBrowserQueryResult =
  Apollo.QueryResult<
    GetDataConnectionStatusForSchemaBrowserQuery,
    GetDataConnectionStatusForSchemaBrowserQueryVariables
  >;
export const DataSourceColumnByIdDocument = /*#__PURE__*/ gql`
  query DataSourceColumnById($dataSourceColumnId: DataSourceColumnId!) {
    dataSourceColumnById(dataSourceColumnId: $dataSourceColumnId) {
      name
      sourceTableName
      id
      type
      dbtDescription
      dbtDescriptionMdStripped
      dbtTests
      comment
      metadata {
        id
        magicDescription
      }
      dataSourceTable {
        id
        name
        dbtAccessUrl
        dbtRunId
        dbtUniqueId
        dbtProjectId
        dbtAccountId
        dataSourceSchema {
          id
          name
          dataSourceDatabase {
            id
            name
          }
        }
      }
    }
  }
`;

/**
 * __useDataSourceColumnByIdQuery__
 *
 * To run a query within a React component, call `useDataSourceColumnByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataSourceColumnByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataSourceColumnByIdQuery({
 *   variables: {
 *      dataSourceColumnId: // value for 'dataSourceColumnId'
 *   },
 * });
 */
export function useDataSourceColumnByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    DataSourceColumnByIdQuery,
    DataSourceColumnByIdQueryVariables
  > &
    (
      | { variables: DataSourceColumnByIdQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DataSourceColumnByIdQuery,
    DataSourceColumnByIdQueryVariables
  >(DataSourceColumnByIdDocument, options);
}
export function useDataSourceColumnByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DataSourceColumnByIdQuery,
    DataSourceColumnByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DataSourceColumnByIdQuery,
    DataSourceColumnByIdQueryVariables
  >(DataSourceColumnByIdDocument, options);
}
// @ts-ignore
export function useDataSourceColumnByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DataSourceColumnByIdQuery,
    DataSourceColumnByIdQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  DataSourceColumnByIdQuery,
  DataSourceColumnByIdQueryVariables
>;
export function useDataSourceColumnByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DataSourceColumnByIdQuery,
        DataSourceColumnByIdQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DataSourceColumnByIdQuery | undefined,
  DataSourceColumnByIdQueryVariables
>;
export function useDataSourceColumnByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DataSourceColumnByIdQuery,
        DataSourceColumnByIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DataSourceColumnByIdQuery,
    DataSourceColumnByIdQueryVariables
  >(DataSourceColumnByIdDocument, options);
}
export type DataSourceColumnByIdQueryHookResult = ReturnType<
  typeof useDataSourceColumnByIdQuery
>;
export type DataSourceColumnByIdLazyQueryHookResult = ReturnType<
  typeof useDataSourceColumnByIdLazyQuery
>;
export type DataSourceColumnByIdSuspenseQueryHookResult = ReturnType<
  typeof useDataSourceColumnByIdSuspenseQuery
>;
export type DataSourceColumnByIdQueryResult = Apollo.QueryResult<
  DataSourceColumnByIdQuery,
  DataSourceColumnByIdQueryVariables
>;
export const DataSourceTableByIdDocument = /*#__PURE__*/ gql`
  query DataSourceTableById($dataSourceTableId: DataSourceTableId!) {
    dataSourceTableById(dataSourceTableId: $dataSourceTableId) {
      name
      id
      columnCount
      tableType
      dbtAccessUrl
      dbtRunId
      dbtUniqueId
      dbtProjectId
      dbtAccountId
      dbtLastRefreshed
      dbtTests
      dbtFreshness
      dbtMetadataError
      dbtWarnAfterCount
      dbtWarnAfterPeriod
      dbtErrorAfterCount
      dbtErrorAfterPeriod
      dbtDescription
      dbtDescriptionMdStripped
      comment
      dataSourceSchema {
        id
        name
        metadata {
          id
          status {
            id
            ...StatusFragment
          }
        }
        dataSourceDatabase {
          id
          name
          metadata {
            id
            status {
              id
              ...StatusFragment
            }
          }
        }
      }
      metadata {
        id
        magicDescription
        status {
          ...StatusFragment
        }
        categories {
          ...CategoryFragment
        }
      }
      columns {
        id
        ...DataSourceColumnFragment
      }
    }
  }
  ${StatusFragmentDoc}
  ${CategoryFragmentDoc}
  ${DataSourceColumnFragmentDoc}
`;

/**
 * __useDataSourceTableByIdQuery__
 *
 * To run a query within a React component, call `useDataSourceTableByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataSourceTableByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataSourceTableByIdQuery({
 *   variables: {
 *      dataSourceTableId: // value for 'dataSourceTableId'
 *   },
 * });
 */
export function useDataSourceTableByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    DataSourceTableByIdQuery,
    DataSourceTableByIdQueryVariables
  > &
    (
      | { variables: DataSourceTableByIdQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DataSourceTableByIdQuery,
    DataSourceTableByIdQueryVariables
  >(DataSourceTableByIdDocument, options);
}
export function useDataSourceTableByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DataSourceTableByIdQuery,
    DataSourceTableByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DataSourceTableByIdQuery,
    DataSourceTableByIdQueryVariables
  >(DataSourceTableByIdDocument, options);
}
// @ts-ignore
export function useDataSourceTableByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DataSourceTableByIdQuery,
    DataSourceTableByIdQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  DataSourceTableByIdQuery,
  DataSourceTableByIdQueryVariables
>;
export function useDataSourceTableByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DataSourceTableByIdQuery,
        DataSourceTableByIdQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DataSourceTableByIdQuery | undefined,
  DataSourceTableByIdQueryVariables
>;
export function useDataSourceTableByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DataSourceTableByIdQuery,
        DataSourceTableByIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DataSourceTableByIdQuery,
    DataSourceTableByIdQueryVariables
  >(DataSourceTableByIdDocument, options);
}
export type DataSourceTableByIdQueryHookResult = ReturnType<
  typeof useDataSourceTableByIdQuery
>;
export type DataSourceTableByIdLazyQueryHookResult = ReturnType<
  typeof useDataSourceTableByIdLazyQuery
>;
export type DataSourceTableByIdSuspenseQueryHookResult = ReturnType<
  typeof useDataSourceTableByIdSuspenseQuery
>;
export type DataSourceTableByIdQueryResult = Apollo.QueryResult<
  DataSourceTableByIdQuery,
  DataSourceTableByIdQueryVariables
>;
export const DataConnectionWithDatabasesByIdDocument = /*#__PURE__*/ gql`
  query dataConnectionWithDatabasesById(
    $dataConnectionId: DataConnectionId!
    $appSessionId: AppSessionId
    $databaseLimit: Int
    $schemaLimit: Int
  ) {
    dataConnectionById(dataConnectionId: $dataConnectionId) {
      id
      connectionName
      lastRefreshed
      status
      databaseCount
      magicUsageStatus
      oauthSchemasApplied
      databases(first: $databaseLimit, appSessionId: $appSessionId) {
        id
        name
        schemaCount
        pinned
        metadata {
          id
          magicDescription
          status {
            ...StatusFragment
          }
          categories {
            ...CategoryFragment
          }
        }
        schemas(first: $schemaLimit, appSessionId: $appSessionId) {
          id
          name
          pinned
          pinnedAt
          metadata {
            id
            magicDescription
            status {
              ...StatusFragment
            }
            categories {
              ...CategoryFragment
            }
          }
        }
      }
    }
  }
  ${StatusFragmentDoc}
  ${CategoryFragmentDoc}
`;

/**
 * __useDataConnectionWithDatabasesByIdQuery__
 *
 * To run a query within a React component, call `useDataConnectionWithDatabasesByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataConnectionWithDatabasesByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataConnectionWithDatabasesByIdQuery({
 *   variables: {
 *      dataConnectionId: // value for 'dataConnectionId'
 *      appSessionId: // value for 'appSessionId'
 *      databaseLimit: // value for 'databaseLimit'
 *      schemaLimit: // value for 'schemaLimit'
 *   },
 * });
 */
export function useDataConnectionWithDatabasesByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    DataConnectionWithDatabasesByIdQuery,
    DataConnectionWithDatabasesByIdQueryVariables
  > &
    (
      | {
          variables: DataConnectionWithDatabasesByIdQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DataConnectionWithDatabasesByIdQuery,
    DataConnectionWithDatabasesByIdQueryVariables
  >(DataConnectionWithDatabasesByIdDocument, options);
}
export function useDataConnectionWithDatabasesByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DataConnectionWithDatabasesByIdQuery,
    DataConnectionWithDatabasesByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DataConnectionWithDatabasesByIdQuery,
    DataConnectionWithDatabasesByIdQueryVariables
  >(DataConnectionWithDatabasesByIdDocument, options);
}
// @ts-ignore
export function useDataConnectionWithDatabasesByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DataConnectionWithDatabasesByIdQuery,
    DataConnectionWithDatabasesByIdQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  DataConnectionWithDatabasesByIdQuery,
  DataConnectionWithDatabasesByIdQueryVariables
>;
export function useDataConnectionWithDatabasesByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DataConnectionWithDatabasesByIdQuery,
        DataConnectionWithDatabasesByIdQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DataConnectionWithDatabasesByIdQuery | undefined,
  DataConnectionWithDatabasesByIdQueryVariables
>;
export function useDataConnectionWithDatabasesByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DataConnectionWithDatabasesByIdQuery,
        DataConnectionWithDatabasesByIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DataConnectionWithDatabasesByIdQuery,
    DataConnectionWithDatabasesByIdQueryVariables
  >(DataConnectionWithDatabasesByIdDocument, options);
}
export type DataConnectionWithDatabasesByIdQueryHookResult = ReturnType<
  typeof useDataConnectionWithDatabasesByIdQuery
>;
export type DataConnectionWithDatabasesByIdLazyQueryHookResult = ReturnType<
  typeof useDataConnectionWithDatabasesByIdLazyQuery
>;
export type DataConnectionWithDatabasesByIdSuspenseQueryHookResult = ReturnType<
  typeof useDataConnectionWithDatabasesByIdSuspenseQuery
>;
export type DataConnectionWithDatabasesByIdQueryResult = Apollo.QueryResult<
  DataConnectionWithDatabasesByIdQuery,
  DataConnectionWithDatabasesByIdQueryVariables
>;
export const DataSourceSchemaTablesDocument = /*#__PURE__*/ gql`
  query DataSourceSchemaTables(
    $dataSourceSchemaId: DataSourceSchemaId!
    $appSessionId: AppSessionId
    $first: Int!
    $after: Cursor
  ) {
    dataSourceSchemaById(dataSourceSchemaId: $dataSourceSchemaId) {
      id
      name
      tableCount
      dataSourceDatabase {
        id
        name
      }
      tables(first: $first, after: $after, appSessionId: $appSessionId) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            ...TableListFragment
          }
        }
      }
    }
  }
  ${TableListFragmentDoc}
`;

/**
 * __useDataSourceSchemaTablesQuery__
 *
 * To run a query within a React component, call `useDataSourceSchemaTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataSourceSchemaTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataSourceSchemaTablesQuery({
 *   variables: {
 *      dataSourceSchemaId: // value for 'dataSourceSchemaId'
 *      appSessionId: // value for 'appSessionId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useDataSourceSchemaTablesQuery(
  baseOptions: Apollo.QueryHookOptions<
    DataSourceSchemaTablesQuery,
    DataSourceSchemaTablesQueryVariables
  > &
    (
      | { variables: DataSourceSchemaTablesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DataSourceSchemaTablesQuery,
    DataSourceSchemaTablesQueryVariables
  >(DataSourceSchemaTablesDocument, options);
}
export function useDataSourceSchemaTablesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DataSourceSchemaTablesQuery,
    DataSourceSchemaTablesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DataSourceSchemaTablesQuery,
    DataSourceSchemaTablesQueryVariables
  >(DataSourceSchemaTablesDocument, options);
}
// @ts-ignore
export function useDataSourceSchemaTablesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DataSourceSchemaTablesQuery,
    DataSourceSchemaTablesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  DataSourceSchemaTablesQuery,
  DataSourceSchemaTablesQueryVariables
>;
export function useDataSourceSchemaTablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DataSourceSchemaTablesQuery,
        DataSourceSchemaTablesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  DataSourceSchemaTablesQuery | undefined,
  DataSourceSchemaTablesQueryVariables
>;
export function useDataSourceSchemaTablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DataSourceSchemaTablesQuery,
        DataSourceSchemaTablesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    DataSourceSchemaTablesQuery,
    DataSourceSchemaTablesQueryVariables
  >(DataSourceSchemaTablesDocument, options);
}
export type DataSourceSchemaTablesQueryHookResult = ReturnType<
  typeof useDataSourceSchemaTablesQuery
>;
export type DataSourceSchemaTablesLazyQueryHookResult = ReturnType<
  typeof useDataSourceSchemaTablesLazyQuery
>;
export type DataSourceSchemaTablesSuspenseQueryHookResult = ReturnType<
  typeof useDataSourceSchemaTablesSuspenseQuery
>;
export type DataSourceSchemaTablesQueryResult = Apollo.QueryResult<
  DataSourceSchemaTablesQuery,
  DataSourceSchemaTablesQueryVariables
>;
export const PinSchemaDocument = /*#__PURE__*/ gql`
  mutation PinSchema(
    $dataConnectionId: DataConnectionId!
    $dataSourceSchemaId: DataSourceSchemaId!
    $pinned: Boolean!
  ) {
    pinSchema(
      dataConnectionId: $dataConnectionId
      dataSourceSchemaId: $dataSourceSchemaId
      pinned: $pinned
    ) {
      id
      ...PinnedSchemaFragment
    }
  }
  ${PinnedSchemaFragmentDoc}
`;
export type PinSchemaMutationFn = Apollo.MutationFunction<
  PinSchemaMutation,
  PinSchemaMutationVariables
>;

/**
 * __usePinSchemaMutation__
 *
 * To run a mutation, you first call `usePinSchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinSchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinSchemaMutation, { data, loading, error }] = usePinSchemaMutation({
 *   variables: {
 *      dataConnectionId: // value for 'dataConnectionId'
 *      dataSourceSchemaId: // value for 'dataSourceSchemaId'
 *      pinned: // value for 'pinned'
 *   },
 * });
 */
export function usePinSchemaMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PinSchemaMutation,
    PinSchemaMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PinSchemaMutation, PinSchemaMutationVariables>(
    PinSchemaDocument,
    options,
  );
}
export type PinSchemaMutationHookResult = ReturnType<
  typeof usePinSchemaMutation
>;
export type PinSchemaMutationResult = Apollo.MutationResult<PinSchemaMutation>;
export type PinSchemaMutationOptions = Apollo.BaseMutationOptions<
  PinSchemaMutation,
  PinSchemaMutationVariables
>;
export const PinTableDocument = /*#__PURE__*/ gql`
  mutation PinTable(
    $dataConnectionId: DataConnectionId!
    $dataSourceTableId: DataSourceTableId!
    $pinned: Boolean!
  ) {
    pinTable(
      dataConnectionId: $dataConnectionId
      dataSourceTableId: $dataSourceTableId
      pinned: $pinned
    ) {
      id
      ...TableListFragment
    }
  }
  ${TableListFragmentDoc}
`;
export type PinTableMutationFn = Apollo.MutationFunction<
  PinTableMutation,
  PinTableMutationVariables
>;

/**
 * __usePinTableMutation__
 *
 * To run a mutation, you first call `usePinTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinTableMutation, { data, loading, error }] = usePinTableMutation({
 *   variables: {
 *      dataConnectionId: // value for 'dataConnectionId'
 *      dataSourceTableId: // value for 'dataSourceTableId'
 *      pinned: // value for 'pinned'
 *   },
 * });
 */
export function usePinTableMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PinTableMutation,
    PinTableMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PinTableMutation, PinTableMutationVariables>(
    PinTableDocument,
    options,
  );
}
export type PinTableMutationHookResult = ReturnType<typeof usePinTableMutation>;
export type PinTableMutationResult = Apollo.MutationResult<PinTableMutation>;
export type PinTableMutationOptions = Apollo.BaseMutationOptions<
  PinTableMutation,
  PinTableMutationVariables
>;
export const ObjectPinnedDocument = /*#__PURE__*/ gql`
  subscription ObjectPinned(
    $dataConnectionId: DataConnectionId!
    $userId: UserId!
  ) {
    dataSourceObjectPinned(
      dataConnectionId: $dataConnectionId
      userId: $userId
    ) {
      databases {
        id
        pinned
      }
      schemas {
        id
        pinned
        dataSourceDatabase {
          id
        }
      }
      tables {
        id
        pinned
        dataSourceSchema {
          id
          dataSourceDatabase {
            id
          }
        }
      }
    }
  }
`;

/**
 * __useObjectPinnedSubscription__
 *
 * To run a query within a React component, call `useObjectPinnedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useObjectPinnedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObjectPinnedSubscription({
 *   variables: {
 *      dataConnectionId: // value for 'dataConnectionId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useObjectPinnedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    ObjectPinnedSubscription,
    ObjectPinnedSubscriptionVariables
  > &
    (
      | { variables: ObjectPinnedSubscriptionVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ObjectPinnedSubscription,
    ObjectPinnedSubscriptionVariables
  >(ObjectPinnedDocument, options);
}
export type ObjectPinnedSubscriptionHookResult = ReturnType<
  typeof useObjectPinnedSubscription
>;
export type ObjectPinnedSubscriptionResult =
  Apollo.SubscriptionResult<ObjectPinnedSubscription>;
export const SearchSchemaElementsDocument = /*#__PURE__*/ gql`
  query SearchSchemaElements(
    $dataConnectionId: [DataConnectionId!]!
    $searchQuery: String!
    $schemaFilters: [SchemaElementSearchSchemaFilter!]
    $tableFilters: [SchemaElementSearchTableFilter!]
    $columnFilters: [SchemaElementSearchColumnFilter!]
    $resultTypes: [SchemaElementSearchResultType!]
    $pinnedOnly: Boolean
    $limit: Int
  ) {
    searchSchemaElements(
      dataConnectionId: $dataConnectionId
      searchQuery: $searchQuery
      schemaFilters: $schemaFilters
      tableFilters: $tableFilters
      columnFilters: $columnFilters
      resultTypes: $resultTypes
      pinnedOnly: $pinnedOnly
      limit: $limit
    ) {
      databases {
        databaseSearchResults {
          ...DataSourceDatabaseResultFragment
        }
      }
      schemas {
        schemaSearchResults {
          ...DataSourceSchemaResultFragment
        }
      }
      tables {
        tableSearchResults {
          ...DataSourceTableResultFragment
        }
      }
      columns {
        columnSearchResults {
          ...DataSourceColumnResultFragment
        }
      }
    }
  }
  ${DataSourceDatabaseResultFragmentDoc}
  ${DataSourceSchemaResultFragmentDoc}
  ${DataSourceTableResultFragmentDoc}
  ${DataSourceColumnResultFragmentDoc}
`;

/**
 * __useSearchSchemaElementsQuery__
 *
 * To run a query within a React component, call `useSearchSchemaElementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSchemaElementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSchemaElementsQuery({
 *   variables: {
 *      dataConnectionId: // value for 'dataConnectionId'
 *      searchQuery: // value for 'searchQuery'
 *      schemaFilters: // value for 'schemaFilters'
 *      tableFilters: // value for 'tableFilters'
 *      columnFilters: // value for 'columnFilters'
 *      resultTypes: // value for 'resultTypes'
 *      pinnedOnly: // value for 'pinnedOnly'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchSchemaElementsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchSchemaElementsQuery,
    SearchSchemaElementsQueryVariables
  > &
    (
      | { variables: SearchSchemaElementsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SearchSchemaElementsQuery,
    SearchSchemaElementsQueryVariables
  >(SearchSchemaElementsDocument, options);
}
export function useSearchSchemaElementsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchSchemaElementsQuery,
    SearchSchemaElementsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SearchSchemaElementsQuery,
    SearchSchemaElementsQueryVariables
  >(SearchSchemaElementsDocument, options);
}
// @ts-ignore
export function useSearchSchemaElementsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchSchemaElementsQuery,
    SearchSchemaElementsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SearchSchemaElementsQuery,
  SearchSchemaElementsQueryVariables
>;
export function useSearchSchemaElementsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchSchemaElementsQuery,
        SearchSchemaElementsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SearchSchemaElementsQuery | undefined,
  SearchSchemaElementsQueryVariables
>;
export function useSearchSchemaElementsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchSchemaElementsQuery,
        SearchSchemaElementsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SearchSchemaElementsQuery,
    SearchSchemaElementsQueryVariables
  >(SearchSchemaElementsDocument, options);
}
export type SearchSchemaElementsQueryHookResult = ReturnType<
  typeof useSearchSchemaElementsQuery
>;
export type SearchSchemaElementsLazyQueryHookResult = ReturnType<
  typeof useSearchSchemaElementsLazyQuery
>;
export type SearchSchemaElementsSuspenseQueryHookResult = ReturnType<
  typeof useSearchSchemaElementsSuspenseQuery
>;
export type SearchSchemaElementsQueryResult = Apollo.QueryResult<
  SearchSchemaElementsQuery,
  SearchSchemaElementsQueryVariables
>;
export const PinSemanticDatasetDocument = /*#__PURE__*/ gql`
  mutation pinSemanticDataset(
    $semanticDatasetId: SemanticDatasetId!
    $pinned: Boolean!
  ) {
    pinSemanticDataset(semanticDatasetId: $semanticDatasetId, pinned: $pinned) {
      id
      ...PinnedSemanticDatasetFragment
    }
  }
  ${PinnedSemanticDatasetFragmentDoc}
`;
export type PinSemanticDatasetMutationFn = Apollo.MutationFunction<
  PinSemanticDatasetMutation,
  PinSemanticDatasetMutationVariables
>;

/**
 * __usePinSemanticDatasetMutation__
 *
 * To run a mutation, you first call `usePinSemanticDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinSemanticDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinSemanticDatasetMutation, { data, loading, error }] = usePinSemanticDatasetMutation({
 *   variables: {
 *      semanticDatasetId: // value for 'semanticDatasetId'
 *      pinned: // value for 'pinned'
 *   },
 * });
 */
export function usePinSemanticDatasetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PinSemanticDatasetMutation,
    PinSemanticDatasetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PinSemanticDatasetMutation,
    PinSemanticDatasetMutationVariables
  >(PinSemanticDatasetDocument, options);
}
export type PinSemanticDatasetMutationHookResult = ReturnType<
  typeof usePinSemanticDatasetMutation
>;
export type PinSemanticDatasetMutationResult =
  Apollo.MutationResult<PinSemanticDatasetMutation>;
export type PinSemanticDatasetMutationOptions = Apollo.BaseMutationOptions<
  PinSemanticDatasetMutation,
  PinSemanticDatasetMutationVariables
>;
